// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"210":"12d10d2c","382":"ede5a88f","438":"90f79306","684":"28fbcd16","702":"176ad8a1","706":"7a1164b5","873":"5a23b07c"}[chunkId] + ".chunk.js";
};